import React, { useState, useEffect } from "react";
import axiosClient from "../../axios";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link, useLocation } from "react-router-dom";

const WeeklyPremiumCard = () => {
  const [data, setData] = useState({
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axiosClient.get("/api/payments", {
          params: { weekly_payments: true },
        });
        setData({
          count: response.data.count,
        });
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (error) {
    return <div className="alert alert-danger">Error: {error}</div>;
  }

  return (
    <div className="card border-0 shadow">
      <div className="card-body bg-danger text-white">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="mb-0">{loading ? "..." : data.count}</h2>
            <p className="text-white text-opacity-75 mb-0">
              New premium this week
            </p>
          </div>
          <div className="bg-white bg-opacity-10 p-3 rounded">
            <i className="bi bi-credit-card-fill fs-2"></i>
          </div>
        </div>
      </div>
      <div className="card-footer bg-danger bg-opacity-10">
        <Link
          to="/xl-admin/users"
          className="float-end small text-muted text-decoration-none"
        >
          More info <i className="bi bi-arrow-right-circle"></i>
        </Link>
      </div>
    </div>
  );
};

export default WeeklyPremiumCard;
